<template>
  <transition name="modal">
    <div 
      v-if="show"
      class="modal-mask position-fixed w-100 h-100 d-table"
      @mousemove.stop
    >
      <div 
        class="d-table-cell vertical-align-top"
        @click.self="close"
      >
        <div
          class="container modal-container bg-sachlich-white py-3" 
          :style="containerStyle"
        >
          <div 
            @click="stop"
            @dblclick="stop"
          >
            <div class="d-flex justify-content-end">
              <Icon 
                type="close"
                @click="close"
              />
            </div>

            <slot />
          </div>

          <div 
            class="row text-center"
            :class="!!cancel || !!ok ? 'mt-3' : ''"
          >
            <div
              v-if="!!cancel"
              class="col"
            >
              <ExpiButton
                :label-id="canceltext"
                button-style="outline"
                :click="cancel"
              />
            </div>
            <div
              v-if="!!ok"
              class="col"
            >
              <ExpiButton
                :label-id="oktext"
                :click="ok"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';
import { ClickCallback } from '../callbacks';
import ExpiButton from './ExpiButton.vue';
import Icon from './Icon.vue';

export default defineComponent({
  components: { ExpiButton, Icon },

  props: {
    show: {
      type: Boolean,
      default: true,
    },
    close: {
      type: Function as PropType<ClickCallback>,
      default: () => undefined,
    },
    cancel: {
      type: Function as PropType<ClickCallback>,
      default: null,
    },
    ok: {
      type: Function as PropType<ClickCallback>,
      default: null,
    },
    canceltext: {
      type: String,
      default: null
    },
    oktext: {
      type: String,
      default: null
    },
    size: {
      type: String as PropType<'default' | 'small' | 'medium' | 'big'>,
      default: 'default',
    },
  },

  computed: {
    containerStyle() {
      let pxsize = ''

      switch(this.size) {
        case 'small': 
          pxsize = '500px'
          break
        case 'medium':
          pxsize = '800px'
          break
        case 'big':
          pxsize = '900px'
          break
        default:
          pxsize = 'none'
          break
      }

      return {
        'max-width': `${pxsize}`,
      }
    },
  },

  methods: {
    stop: (event: MouseEvent) => {
      event.preventDefault()
      event.stopPropagation()
    },
  },
})
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.modal-mask {
  z-index: 100;
  top: 0;
  left: 0;
  transition: opacity 0.3s ease;
}

.modal-container {
  min-width: 300px;
  margin-top: 100px;
  box-shadow: 0 8px 30px 8px rgba(0, 0, 0, 0.22);
  transition: all 0.3s ease;

  @media only screen and (max-width: 350px) {
    margin-top: -5px;
  }
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.modal-enter-from,
.modal-leave-active {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
